import React from 'react'
import i18next from 'i18next'
import hash from 'object-hash'
import { connect } from 'react-redux'
import { getConstants } from 'src/lib/constants'
import { Modal, Button, Card, Badge } from 'react-bootstrap'
import ActionsDropdown from 'src/components/system_wide/actions_dropdown'
import SearchButton from 'src/components/system_wide/search_button'
import ResponsiveTable from 'src/components/system_wide/responsive_table'
import FilterGroup from 'src/components/system_wide/filter_group'
import CheckboxFilter from 'src/components/system_wide/checkbox_filter'
import SelectAgentsModal from 'src/components/system_wide/select_agents_modal'
import ContractForm from './contract_form'
import { Trans } from 'react-i18next'

import {
  setCurrentContract,
  createContract,
  updateContract,
  deleteContract,
  toggleShowForm,
  getContracts,
  resetCurrentContract,
  resetContracts,
  changeStatusContract,
} from 'src/store/contracts'
import { getAllUsers } from 'src/store/users'
import { getAllBrands } from 'src/store/brand'
import ChangeContractStatusModal from './change_contract_status_modal'
import { checkCapabilities, WithCapabilitiesWrapper } from 'src/enhancers/with_capabilities'
import { format, parseISO } from 'date-fns'

const { t } = i18next

const mstp = state => {
  let { total, contracts, show_form, current_contract, pending } = state.contracts
  let { id, business_role_priority } = state.userInfo
  let { all_brands: brands } = state.brands
  let { all_users: users } = state.users
  const can_manage = checkCapabilities(['manage_contracts'])
  const can_change_status = checkCapabilities(['change_status_contracts'])
  return {
    pending,
    user_id: id,
    business_role_priority,
    total,
    contracts,
    show_form,
    current_contract,
    can_manage,
    can_change_status,
    brands,
    users,
  }
}

class ManageContracts extends React.Component {
  state = {
    show_modal: false,
    filter: '',
    filtered_brands: [],
    filtered_statuses: [],
    filtered_users: [],
    mode: '',

    filters_hash: '',
    ready: false,
  }

  tableRef = null
  changeStatusModalRef = null
  selectAgentsModalRef = null
  filter_statuses = []

  constructor(props) {
    super(props)
    this.tableRef = React.createRef()
    this.changeStatusModalRef = React.createRef()
    this.selectAgentsModalRef = React.createRef()
    this.filter_statuses = getConstants().contract_statuses
    this.filter_statuses = Object.keys(this.filter_statuses).map(k => ({ id: k, name: this.filter_statuses[k] }))
    this.state.filtered_statuses = this.filter_statuses.map(s => s.id)
  }

  async componentDidMount() {
    await this.props.dispatch(getAllBrands())
    await this.props.dispatch(getAllUsers({ filtered_roles_priority: [4] }))
    this.setState(
      {
        filtered_brands: this.props.brands.map(b => b.id),
        filtered_users: this.props.users.map(u => u.id),
        ready: true,
      },
      () => {
        let { filtered_brands, filtered_users, filtered_statuses } = this.state
        filtered_brands.sort()
        filtered_users.sort()
        filtered_statuses.sort()
        this.initialFiltersHash = hash({
          filtered_brands: filtered_brands,
          filtered_users: filtered_users,
          filtered_statuses: filtered_statuses,
        })
        this.updateFiltersHash()
        this.tableRef?.current?.refreshData()
      }
    )
  }

  updateFiltersHash = () => {
    let { filtered_brands, filtered_users, filtered_statuses } = this.state
    filtered_brands.sort()
    filtered_users.sort()
    filtered_statuses.sort()
    this.setState({ filters_hash: hash({ filtered_brands, filtered_users, filtered_statuses }) })
  }

  actions = [
    {
      icon: 'fas fa-eye',
      text: t('actions.view', 'Visualizza'),
      variant: 'outline-primary',
      onClick: rowData => {
        this.setState({ mode: 'view' })
        this.props.dispatch(setCurrentContract({ ...rowData }))
        this.props.dispatch(toggleShowForm())
      },
    },
    {
      name: 'edit',
      icon: 'fas fa-edit',
      text: t('actions.edit', 'Modifica'),
      variant: 'outline-warning',
      disabled: rowData => rowData.status !== 'pending',
      visible: () => this.props.can_manage,
      onClick: rowData => {
        this.props.dispatch(setCurrentContract({ ...rowData }))
        this.props.dispatch(toggleShowForm())
      },
    },
    {
      name: 'delete',
      icon: 'fas fa-trash-alt',
      text: t('actions.delete', 'Elimina'),
      variant: 'outline-danger',
      disabled: rowData => rowData.status !== 'pending',
      visible: () => this.props.can_manage,
      onClick: rowData => {
        this.props.dispatch(setCurrentContract({ ...rowData }))
        this.setState({ show_modal: true })
      },
    },
    { name: 'separator', text: '---', visible: () => this.props.can_manage },
    {
      name: 'change_status',
      icon: 'fas fa-exchange-alt',
      variant: 'outline-info',
      text: t('actions.change_status', 'Cambia stato'),
      visible: () => this.props.can_change_status,
      onClick: ({ id, appointment: { code, success_at }, status, ...rest }) => {
        let date = success_at
        if (status === 'signed') {
          date = parseISO(rest.signed_at)
        } else if (status === 'rejected') {
          date = parseISO(rest.rejected_at)
        } else if (status === 'expired') {
          date = parseISO(rest.expires_at)
        }
        this.changeStatusModalRef?.current?.show({ id, code, status, date, minDate: parseISO(success_at) })
      },
    },
  ]

  actionsRenderer = ({ rowData }) => {
    return <ActionsDropdown rowData={rowData} actions={this.actions} />
  }

  renderStatus = ({ status, signed_at, rejected_at, expires_at }) => {
    const _filter_statuses = this.filter_statuses.reduce((acc, s) => ({ ...acc, [s.id]: s.name }), {})

    const statusMap = {
      signed: { text: _filter_statuses['signed'], color: 'success', date: signed_at },
      rejected: { text: _filter_statuses['rejected'], color: 'danger', date: rejected_at },
      pending: { text: _filter_statuses['pending'], color: 'warning', date: null },
      expired: { text: _filter_statuses['expired'], color: 'dark', date: expires_at },
    }

    const { text, color, date } = statusMap[status] || statusMap.default

    return (
      <div className="text-center">
        <Badge bg={color} className="px-3 py-2 text-uppercase shadow-sm" style={{ fontSize: '1rem' }}>
          {text}
          {date && (
            <div className="small mt-1">
              <em>{format(parseISO(date), 'dd/MM/yyyy')}</em>
            </div>
          )}
        </Badge>
      </div>
    )
  }

  renderDetails = rowData => {
    const { appointment, sig_name, created_by_name } = rowData
    const { dealer, code, brand_name } = appointment
    const value = this.props.business_role_priority === 4 ? dealer.business_name : code
    return (
      <Card className="shadow-lg mb-4 border-0 rounded-lg">
        <Card.Body className="pb-2 pt-2">
          <h5 className="fw-bold text-primary">{value}</h5>
          {this.props.business_role_priority !== 4 && (
            <p className="text-muted mb-1">
              <i className="fas fa-building me-2"></i>
              {dealer.business_name}
            </p>
          )}
          <p className="text-muted mb-1">
            <i className="fas fa-map-marker-alt me-2"></i>
            {dealer.address}
          </p>
          <p className="text-muted mb-1">
            <i className="fas fa-user me-2"></i>
            {sig_name}
          </p>
          <p className="text-muted mb-1">
            <i className="fas fa-tag me-2"></i>
            {brand_name}
          </p>
          {this.props.business_role_priority !== 4 && (
            <p className="text-muted mb-1">
              <i className="fas fa-user-edit me-2"></i>
              {created_by_name}
            </p>
          )}
          {this.renderStatus(rowData)}
        </Card.Body>
        <Card.Footer className="text-center bg-light pb-3 pt-3">
          <div className="d-flex justify-content-around flex-wrap">
            {this.actions
              .filter(a => {
                if (a.name === 'separator') {
                  return false
                }
                if (typeof a.visible === 'function') {
                  return a.visible(rowData, a)
                }
                return a?.visible ?? true
              })
              .map((action, index) => (
                <Button
                  key={index}
                  variant={action.variant}
                  size="sm"
                  title={action.text}
                  disabled={
                    typeof action.disabled === 'function' ? action.disabled(rowData) : action?.disabled ?? false
                  }
                  onClick={() => action.onClick(rowData)}>
                  <i className={`${action.icon} me-0`}></i>
                </Button>
              ))}
          </div>
        </Card.Footer>
      </Card>
    )
  }

  columns = [
    {
      title: '',
      className: 'd-none d-sm-block text-center',
      style: { width: '6%', minWidth: '3rem' },
      data: this.actionsRenderer,
    },
    {
      title: t('components.contracts.appointment_code', 'Codice visita'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '12%' },
      sortable: false,
      data: ({ rowData: { appointment } }) => appointment.code,
    },
    {
      title: t('components.contracts.business_name', 'Ragione sociale'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '12%' },
      sortable: false,
      sortingKey: 'dealer_business_name',
      data: ({ rowData: { appointment } }) => (
        <div>
          {appointment?.dealer?.business_name ?? ''} <br />
          {appointment?.dealer?.piva ?? ''}
        </div>
      ),
    },
    {
      title: t('components.contracts.address', 'Indirizzo'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '12%' },
      sortable: true,
      soring_key: 'dealer_address',
      data: ({ rowData: { appointment } }) => appointment?.dealer?.address ?? '',
    },
    {
      title: t('components.contracts.signer', 'Firmatario'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '12%' },
      sortable: true,
      sortingKey: 'sig_name',
      data: ({ rowData: { sig_name } }) => {
        return sig_name
      },
    },
    {
      title: t('components.contracts.brand', 'Brand'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '12%' },
      sortable: true,
      sortingKey: 'brand_name',
      data: ({ rowData: { appointment } }) => appointment.brand_name,
    },
    {
      title: t('components.contracts.created_by', 'Creato da'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '12%' },
      sortable: true,
      data: 'created_by_name',
    },
    {
      name: 'status',
      title: t('components.contracts.status', 'Stato'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '12%' },
      sortingKey: 'status',
      sortable: true,
      data: ({ rowData }) => this.renderStatus(rowData),
    },
    {
      title: t('components.appointments.details', 'Dettagli'),
      className: 'd-block d-sm-none flex-fill',
      style: { width: '100%' },
      data: ({ rowData }) => this.renderDetails(rowData),
    },
  ]

  getColumns = () => {
    return this.columns
  }

  onFilterChange = filter => this.setState({ filter })
  onChangeFilter = name => values => {
    if (name === 'filtered_users') {
      values = values.map(user => user.id)
    }
    this.setState({ [name]: values }, () => {
      this.updateFiltersHash()
      this.tableRef?.current?.refreshData()
    })
  }

  getData = async (index = 0, chunkSize, sortData, filter) => {
    let { ready, filtered_brands, filtered_users, filtered_statuses } = this.state
    if (!ready) return
    await this.props.dispatch(
      getContracts({
        offset: index,
        limit: chunkSize,
        sortData,
        filter,
        filtered_brands,
        filtered_users,
        filtered_statuses,
      })
    )
  }

  saveContract = async contract => {
    let { appointment, ...rest } = contract
    let _contract = { ...rest, appointment_id: appointment.id, created_by: appointment.created_by }
    contract.id
      ? await this.props.dispatch(updateContract({ contract: _contract }))
      : await this.props.dispatch(createContract({ contract: _contract }))
    this.tableRef.current.refreshData()
  }

  onToggleForm = () => {
    if (this.props.show_form === true) {
      this.setState({ mode: '' })
      this.props.dispatch(resetCurrentContract())
    }
    this.props.dispatch(toggleShowForm())
  }

  onCancel = () => {
    this.props.dispatch(resetCurrentContract())
    this.setState({ show_modal: false })
  }

  onConfirmDelete = async () => {
    await this.props.dispatch(deleteContract({ id: this.props.current_contract.id }))
    this.tableRef.current.refreshData()
    this.setState({ show_modal: false })
  }

  componentWillUnmount() {
    this.props.dispatch(resetContracts())
  }

  onChangeStatus = async contract => {
    let { id, status, date } = contract

    await this.props.dispatch(changeStatusContract({ id, status, date: date ? format(date, 'yyyy-MM-dd') : null }))
    this.tableRef.current.refreshData()
  }

  onResetFilters = () => {
    this.setState(
      {
        filtered_brands: this.props.brands.map(b => b.id),
        filtered_statuses: this.filter_statuses.map(s => s.id),
        filtered_users: this.props.users.map(u => u.id),
      },
      () => {
        this.tableRef?.current?.refreshData()
        this.updateFiltersHash()
      }
    )
  }

  render() {
    let { show_modal, filter, mode, filtered_brands, filtered_users, filtered_statuses, filters_hash } = this.state
    let { show_form, business_role_priority, current_contract, total, contracts, pending, user_id, users, brands } =
      this.props
    let title = t('components.contracts.create_contract', 'Crea pratica contrattuale')
    if (current_contract.id) {
      title =
        mode === 'view'
          ? t('components.contracts.view_contract', 'Visualizza contratto')
          : t('components.contracts.edit_contract', 'Modifica contratto')
    }
    return (
      <div className="card card-body container-fluid flex-fill d-flex flex-column px-0 pb-0 pt-2 mb-0">
        <div className="d-flex flex-column flex-fill">
          <div className="toolbar px-2 flex-wrap">
            <WithCapabilitiesWrapper has={['manage_contracts']}>
              <Button size="sm" onClick={this.onToggleForm} disabled={show_form}>
                <i className="fas fa-plus fa-fw text-start me-0 ps-1 ps-sm-0" />
                <span className="d-none d-sm-inline">
                  <Trans i18nKey="buttons.add_contract">Aggiungi pratica contrattuale</Trans>
                </span>
              </Button>
            </WithCapabilitiesWrapper>

            <FilterGroup
              className="toolbar-item"
              showResetFilters={this.initialFiltersHash !== filters_hash}
              onResetFilters={this.onResetFilters}>
              <CheckboxFilter
                label={t('filter_brands', 'Brand')}
                items={brands}
                filteredItems={filtered_brands}
                onChangeFilter={this.onChangeFilter('filtered_brands')}
                showSearch={true}
              />
              <CheckboxFilter
                label={t('filter_status', 'Stato')}
                items={this.filter_statuses}
                filteredItems={filtered_statuses}
                onChangeFilter={this.onChangeFilter('filtered_statuses')}
                showSearch={true}
              />
              {users.length > 0 && users[0].id !== user_id && (
                <Button
                  className="dropdown-toggle btn btn-primary"
                  onClick={() => this.selectAgentsModalRef.current.show({ selected_users: filtered_users })}>
                  <Trans i18nKey="filter_agents">Funzionari</Trans>
                </Button>
              )}
            </FilterGroup>
            <div className="toolbar-spacer"></div>
            <div className="flex-fill">
              <SearchButton
                value={filter}
                onChange={this.onFilterChange}
                disabled={this.props.show_form}
                className="float-md-end"
              />
            </div>
          </div>

          <ResponsiveTable
            ref={this.tableRef}
            className="flex-fill"
            data={contracts}
            getData={this.getData}
            totalRecords={total}
            columns={this.getColumns()}
            showMenu={show_form}
            modalSize="md"
            dialogClassName="modal-90w"
            menuContent={ContractForm}
            menuContentProps={{
              title: title,
              business_role_priority: business_role_priority,
              contract: current_contract,
              pending: pending,
              onSave: this.saveContract,
              closeForm: this.onToggleForm,
              readonly: mode === 'view',
              forceUseModal: true,
            }}
            rowClasses={rowData => (rowData.enabled ? '' : `text-muted`)}
            filter={filter}
          />
        </div>

        <Modal backdrop="static" centered show={show_modal} onHide={this.onCancel}>
          <Modal.Header>
            <Modal.Title>
              <Trans i18nKey="components.contracts.delete_contract_modal.title">Elimina contratto</Trans>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              <Trans
                i18nKey="components.contracts.delete_contract_modal.description"
                values={{ appointment: this.props.current_contract?.appointment?.code }}
                defaults={`Per procedere all'eliminazione della pratica contrattuale relativo alla visita <1>{{appointment}}</1>, cliccare sul bottone "Elimina"`}
                components={{ 1: <b /> }}
              />
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.onCancel}>
              <Trans i18nKey="buttons.cancel">Annulla</Trans>
            </Button>
            <Button variant="danger" onClick={this.onConfirmDelete}>
              <Trans i18nKey="buttons.delete">Elimina</Trans>
            </Button>
          </Modal.Footer>
        </Modal>
        <ChangeContractStatusModal ref={this.changeStatusModalRef} onSave={this.onChangeStatus} pending={pending} />

        <SelectAgentsModal
          ref={this.selectAgentsModalRef}
          users={users}
          brands={brands}
          selected_user={filtered_users}
          onChange={this.onChangeFilter('filtered_users')}
          multiSelection={true}
        />
      </div>
    )
  }
}

export default connect(mstp)(ManageContracts)
